import { timestampApi } from '@deepup/apis';
import { DateTime } from 'luxon';
import { convertBigInt } from './number';

export const timestampToIsoString = (timestamp?: timestampApi.Timestamp) => {
  if (!timestamp) {
    return '';
  }

  const date = timestampApi.Timestamp.toDate(timestamp);
  return date.toISOString();
};

export const convertToTimestampApi = (
  date?: string | DateTime,
): timestampApi.Timestamp | undefined => {
  if (!date) {
    return;
  }

  const jsDate = date instanceof DateTime ? date.toJSDate() : new Date(date);
  return convertBigInt(timestampApi.Timestamp.fromDate(jsDate));
};
